import * as React from 'react'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import { useCommonCtx } from '../context/useCommonCtx'
import { useTranslation } from '../i18n/useTranslation'
import { AlertProps } from '../hooks/useAlert'

export function MyDialog(p: AlertProps) {
    const t = useTranslation(useCommonCtx())

    return (
        <Dialog
            open={p.open}
            onClose={p.onCancel}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">{p.title}</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    {p.message}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={p.onCancel}>{t('btn_cancel')}</Button>
                <Button onClick={p.onConfirm} autoFocus>
                    OK
                </Button>
            </DialogActions>
        </Dialog>
    )
}
